import type { Meta, StoryObj } from "@storybook/react";
import { subDays } from "date-fns";

import type { SMTWeekLogProps } from "@/ui/components/smt/SMTWeekLogSection";
import { SMTWeekLog } from "@/ui/components/smt/SMTWeekLogSection";

const StoryMeta: Meta<SMTWeekLogProps> = {
  title: "Components/SMT/SMT Week Log",
  component: SMTWeekLog,
  argTypes: {
    canAddEntries: { control: "boolean" },
    datesWithLogs: { control: "object" },
    onAddEntryPress: { action: "add entry pressed" },
  },
  args: {
    datesWithLogs: [],
  },
};

type Story = StoryObj<SMTWeekLogProps>;

const Default: Story = {
  args: {
    canAddEntries: true,
    datesWithLogs: [],
    globalStreak: 0,
  },
};

const WithStreak: Story = {
  args: {
    ...Default.args,
    datesWithLogs: [
      subDays(new Date(), 0),
      subDays(new Date(), 1),
      subDays(new Date(), 2),
    ],
    globalStreak: 3,
  },
};

const WithMultipleStreaks: Story = {
  args: {
    ...Default.args,
    datesWithLogs: [
      subDays(new Date(), 0),
      subDays(new Date(), 1),
      subDays(new Date(), 2),
      subDays(new Date(), 4),
      subDays(new Date(), 5),
    ],
    globalStreak: 3,
  },
};

const WithWeekStreak: Story = {
  args: {
    ...Default.args,
    datesWithLogs: [
      subDays(new Date(), 0),
      subDays(new Date(), 1),
      subDays(new Date(), 2),
      subDays(new Date(), 3),
      subDays(new Date(), 4),
      subDays(new Date(), 5),
      subDays(new Date(), 6),
    ],
    globalStreak: 7,
  },
};

const WithoutAddEntry: Story = {
  args: {
    canAddEntries: false,
    datesWithLogs: [
      subDays(new Date(), 0),
      subDays(new Date(), 2),
      subDays(new Date(), 4),
    ],
    globalStreak: 0,
  },
};

export {
  Default,
  WithMultipleStreaks,
  WithoutAddEntry,
  WithStreak,
  WithWeekStreak,
};
export default StoryMeta;
